import '../App.css'

export const NewsRecap = ({ data }) => {

    const numeroItemsCantidades = data && data.allInfos.filter(({ tipo }) => tipo === "Cantidades").length
    const cantidadesMasDeUno = data && data.allInfos.filter(({ tipo }) => tipo === "Cantidades")
        .filter(({ titulo }) => titulo.match(/\d+/g)).length
    const totalCantidadesMasDeUno = data && data.allInfos.filter(({ tipo }) => tipo === "Cantidades")
        .filter(({ titulo }) => titulo.match(/\d+/g))
        .map(({ titulo }) => titulo.match(/\d+/g))
        .map(Number)
        .reduce((a, b) => {
            return a + b
        }, 0)
    const numeroMostrarTotalCantidades = numeroItemsCantidades + totalCantidadesMasDeUno - cantidadesMasDeUno

    const numeroItemsDespidos = data && data.allInfos.filter(({ tipo }) => tipo === "Despidos").length
    const despidosMasDeUno = data && data.allInfos.filter(({ tipo }) => tipo === "Despidos")
        .filter(({ titulo }) => titulo.match(/\d+/g)).length
    const totalDespidosMasDeUno = data && data.allInfos.filter(({ tipo }) => tipo === "Despidos")
        .filter(({ titulo }) => titulo.match(/\d+/g))
        .map(({ titulo }) => titulo.match(/\d+/g))
        .map(Number)
        .reduce((a, b) => {
            return a + b
        }
            , 0)
    const numeroMostrarTotalDespidos = numeroItemsDespidos + totalDespidosMasDeUno - despidosMasDeUno

    const numeroItemsSancion = data && data.allInfos.filter(({ tipo }) => tipo === "Sanción").length
    const sancionesMasDeUno = data && data.allInfos.filter(({ tipo }) => tipo === "Sanción")
        .filter(({ titulo }) => titulo.match(/\d+/g)).length
    const totalSancionesMasDeUno = data && data.allInfos.filter(({ tipo }) => tipo === "Sanción")
        .filter(({ titulo }) => titulo.match(/\d+/g))
        .map(({ titulo }) => titulo.match(/\d+/g))
        .map(Number)
        .reduce((a, b) => {
            return a + b
        }
            , 0)
    const numeroMostrarTotalSancion = numeroItemsSancion + totalSancionesMasDeUno - sancionesMasDeUno

    const numeroItemsOtros = data && data.allInfos.filter(({ tipo }) => tipo === "Otros").length
    const otrosMasDeUno = data && data.allInfos.filter(({ tipo }) => tipo === "Otros")
        .filter(({ titulo }) => titulo.match(/\d+/g)).length
    const totalOtrosMasDeUno = data && data.allInfos.filter(({ tipo }) => tipo === "Otros")
        .filter(({ titulo }) => titulo.match(/\d+/g))
        .map(({ titulo }) => titulo.match(/\d+/g))
        .map(Number)
        .reduce((a, b) => {
            return a + b
        }
            , 0)
    const numeroMostrarTotalOtros = numeroItemsOtros + totalOtrosMasDeUno - otrosMasDeUno

    return (
        <div className='table'>
            <h3>Resumen de juicios ganados desde Noviembre 2024:</h3>

            <ul>
                <div className='flex-items'>
                    <li>reclamacion de cantidades:</li><div>{numeroMostrarTotalCantidades? numeroMostrarTotalCantidades.toString():0}</div>
                </div>

                <div className='flex-items'>
                    <li>despidos:</li><div>{numeroMostrarTotalDespidos? numeroMostrarTotalDespidos.toString():0}</div>
                </div>

                <div className='flex-items'>
                    <li>sanciones:</li><div>{numeroMostrarTotalSancion? numeroMostrarTotalSancion.toString():0}</div>
                </div>

                <div className='flex-items'>
                    <li>otros:</li><div>{numeroMostrarTotalOtros ? numeroMostrarTotalOtros.toString() : 0}</div>
                </div>
            </ul>
        </div>
    )
}